import { format } from "date-fns";
import type { AcquireBookPictures } from "@/types/acquirebook";
import {
  type OwnerRelatedAcquireOption,
  type OwnerRelatedRegistryResponse,
} from "@/types/ownerRelatedRegistries";

const pictureTypeLabels: Record<string, string> = {
  SHOYUSHAJIKO: "所有者事項",
  ZENBUJIKO: "全部事項",
  CHISEKISOKURYOZU: "地積測量図",
  DENSHIKOZU: "電子公図",
  CHIEKIKENZUMEN: "地役権図面",
  TATEMONOZUMEN: "建物図面",
};

const acquireOptionLabels: Record<OwnerRelatedAcquireOption, string> = {
  reuse: "リユース",
  new: "新規",
  retained: "取得済み",
};

export const getPictureTypeLabel = (
  type: AcquireBookPictures | string
): string => {
  return pictureTypeLabels[type] ?? type;
};

export const getAcquireOptionLabel = (
  option: OwnerRelatedAcquireOption
): string => {
  return acquireOptionLabels[option];
};

export const defaultAcquireOptionForRegistry = (
  registry: OwnerRelatedRegistryResponse
): OwnerRelatedAcquireOption => {
  if (registry.reuseRegistry) {
    return "reuse";
  }
  if (registry.retainedRegistry) {
    return "retained";
  }
  return "new";
};

export const formatNames = (names: string[]): string => {
  if (!names || names.length === 0) {
    return "-";
  }
  if (names.length <= 2) {
    return names.join("、");
  }
  const [first, second] = names;
  return `${first}、${second}、ほか${names.length - 2}名`;
};

export const formatDateLabel = (value?: string | null): string => {
  if (!value) {
    return "-";
  }
  try {
    return format(new Date(value), "yyyy/MM/dd");
  } catch (error) {
    return "-";
  }
};

export const createOwnerRelatedRegistryId = (
  registry: OwnerRelatedRegistryResponse
): string => {
  const {
    realEstateType,
    pictureType,
    prefectureName,
    addressText,
    chibanKaokuNumber,
    reuseRegistry,
    retainedRegistry,
  } = registry;

  return [
    realEstateType ?? "",
    pictureType ?? "",
    prefectureName ?? "",
    addressText ?? "",
    chibanKaokuNumber ?? "",
    reuseRegistry?.id ?? "",
    retainedRegistry?.id ?? "",
  ].join(":");
};
